/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb = require('../../../../../../github.com/solo-io/dev-portal/api/dev-portal/v1beta1/common/common_pb.js');
var github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_pb = require('../../../../../../github.com/solo-io/solo-apis/api/gloo/gloo/v1/options_pb.js');
var github_com_solo$io_cue_encoding_protobuf_cue_cue_pb = require('../../../../../../github.com/solo-io/cue/encoding/protobuf/cue/cue_pb.js');
var extproto_ext_pb = require('../../../../../../extproto/ext_pb.js');
goog.exportSymbol('proto.portal.gloo.solo.io.RouteSpec', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.RouteSpecifier', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.RouteStatus', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.RoutingDestination', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.RouteSpec = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.portal.gloo.solo.io.RouteSpec.repeatedFields_, null);
};
goog.inherits(proto.portal.gloo.solo.io.RouteSpec, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.RouteSpec.displayName = 'proto.portal.gloo.solo.io.RouteSpec';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.portal.gloo.solo.io.RouteSpec.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.RouteSpec.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.RouteSpec.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.RouteSpec} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.RouteSpec.toObject = function(includeInstance, msg) {
  var f, obj = {
    disable: jspb.Message.getFieldWithDefault(msg, 1, false),
    backendsList: jspb.Message.toObjectList(msg.getBackendsList(),
    proto.portal.gloo.solo.io.RoutingDestination.toObject, includeInstance),
    options: (f = msg.getOptions()) && github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_pb.RouteOptions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.RouteSpec}
 */
proto.portal.gloo.solo.io.RouteSpec.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.RouteSpec;
  return proto.portal.gloo.solo.io.RouteSpec.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.RouteSpec} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.RouteSpec}
 */
proto.portal.gloo.solo.io.RouteSpec.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisable(value);
      break;
    case 2:
      var value = new proto.portal.gloo.solo.io.RoutingDestination;
      reader.readMessage(value,proto.portal.gloo.solo.io.RoutingDestination.deserializeBinaryFromReader);
      msg.addBackends(value);
      break;
    case 3:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_pb.RouteOptions;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_pb.RouteOptions.deserializeBinaryFromReader);
      msg.setOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.RouteSpec.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.RouteSpec.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.RouteSpec} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.RouteSpec.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisable();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getBackendsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.portal.gloo.solo.io.RoutingDestination.serializeBinaryToWriter
    );
  }
  f = message.getOptions();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_pb.RouteOptions.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool disable = 1;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.portal.gloo.solo.io.RouteSpec.prototype.getDisable = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.portal.gloo.solo.io.RouteSpec.prototype.setDisable = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated RoutingDestination backends = 2;
 * @return {!Array<!proto.portal.gloo.solo.io.RoutingDestination>}
 */
proto.portal.gloo.solo.io.RouteSpec.prototype.getBackendsList = function() {
  return /** @type{!Array<!proto.portal.gloo.solo.io.RoutingDestination>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.portal.gloo.solo.io.RoutingDestination, 2));
};


/** @param {!Array<!proto.portal.gloo.solo.io.RoutingDestination>} value */
proto.portal.gloo.solo.io.RouteSpec.prototype.setBackendsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.portal.gloo.solo.io.RoutingDestination=} opt_value
 * @param {number=} opt_index
 * @return {!proto.portal.gloo.solo.io.RoutingDestination}
 */
proto.portal.gloo.solo.io.RouteSpec.prototype.addBackends = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.portal.gloo.solo.io.RoutingDestination, opt_index);
};


proto.portal.gloo.solo.io.RouteSpec.prototype.clearBackendsList = function() {
  this.setBackendsList([]);
};


/**
 * optional gloo.solo.io.RouteOptions options = 3;
 * @return {?proto.gloo.solo.io.RouteOptions}
 */
proto.portal.gloo.solo.io.RouteSpec.prototype.getOptions = function() {
  return /** @type{?proto.gloo.solo.io.RouteOptions} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_pb.RouteOptions, 3));
};


/** @param {?proto.gloo.solo.io.RouteOptions|undefined} value */
proto.portal.gloo.solo.io.RouteSpec.prototype.setOptions = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.portal.gloo.solo.io.RouteSpec.prototype.clearOptions = function() {
  this.setOptions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.RouteSpec.prototype.hasOptions = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.RouteSpecifier = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.portal.gloo.solo.io.RouteSpecifier.oneofGroups_);
};
goog.inherits(proto.portal.gloo.solo.io.RouteSpecifier, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.RouteSpecifier.displayName = 'proto.portal.gloo.solo.io.RouteSpecifier';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.portal.gloo.solo.io.RouteSpecifier.oneofGroups_ = [[4,5,6]];

/**
 * @enum {number}
 */
proto.portal.gloo.solo.io.RouteSpecifier.RouteSpecifierCase = {
  ROUTE_SPECIFIER_NOT_SET: 0,
  ROUTEREF: 4,
  INLINEROUTE: 5,
  ENVIRONMENT_ROUTE: 6
};

/**
 * @return {proto.portal.gloo.solo.io.RouteSpecifier.RouteSpecifierCase}
 */
proto.portal.gloo.solo.io.RouteSpecifier.prototype.getRouteSpecifierCase = function() {
  return /** @type {proto.portal.gloo.solo.io.RouteSpecifier.RouteSpecifierCase} */(jspb.Message.computeOneofCase(this, proto.portal.gloo.solo.io.RouteSpecifier.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.RouteSpecifier.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.RouteSpecifier.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.RouteSpecifier} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.RouteSpecifier.toObject = function(includeInstance, msg) {
  var f, obj = {
    routeref: (f = msg.getRouteref()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.toObject(includeInstance, f),
    inlineroute: (f = msg.getInlineroute()) && proto.portal.gloo.solo.io.RouteSpec.toObject(includeInstance, f),
    environmentRoute: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.RouteSpecifier}
 */
proto.portal.gloo.solo.io.RouteSpecifier.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.RouteSpecifier;
  return proto.portal.gloo.solo.io.RouteSpecifier.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.RouteSpecifier} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.RouteSpecifier}
 */
proto.portal.gloo.solo.io.RouteSpecifier.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 4:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.deserializeBinaryFromReader);
      msg.setRouteref(value);
      break;
    case 5:
      var value = new proto.portal.gloo.solo.io.RouteSpec;
      reader.readMessage(value,proto.portal.gloo.solo.io.RouteSpec.deserializeBinaryFromReader);
      msg.setInlineroute(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnvironmentRoute(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.RouteSpecifier.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.RouteSpecifier.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.RouteSpecifier} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.RouteSpecifier.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRouteref();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.serializeBinaryToWriter
    );
  }
  f = message.getInlineroute();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.portal.gloo.solo.io.RouteSpec.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional common.portal.gloo.solo.io.ObjectRef routeRef = 4;
 * @return {?proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.portal.gloo.solo.io.RouteSpecifier.prototype.getRouteref = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef, 4));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectRef|undefined} value */
proto.portal.gloo.solo.io.RouteSpecifier.prototype.setRouteref = function(value) {
  jspb.Message.setOneofWrapperField(this, 4, proto.portal.gloo.solo.io.RouteSpecifier.oneofGroups_[0], value);
};


proto.portal.gloo.solo.io.RouteSpecifier.prototype.clearRouteref = function() {
  this.setRouteref(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.RouteSpecifier.prototype.hasRouteref = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional RouteSpec inlineRoute = 5;
 * @return {?proto.portal.gloo.solo.io.RouteSpec}
 */
proto.portal.gloo.solo.io.RouteSpecifier.prototype.getInlineroute = function() {
  return /** @type{?proto.portal.gloo.solo.io.RouteSpec} */ (
    jspb.Message.getWrapperField(this, proto.portal.gloo.solo.io.RouteSpec, 5));
};


/** @param {?proto.portal.gloo.solo.io.RouteSpec|undefined} value */
proto.portal.gloo.solo.io.RouteSpecifier.prototype.setInlineroute = function(value) {
  jspb.Message.setOneofWrapperField(this, 5, proto.portal.gloo.solo.io.RouteSpecifier.oneofGroups_[0], value);
};


proto.portal.gloo.solo.io.RouteSpecifier.prototype.clearInlineroute = function() {
  this.setInlineroute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.RouteSpecifier.prototype.hasInlineroute = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string environment_route = 6;
 * @return {string}
 */
proto.portal.gloo.solo.io.RouteSpecifier.prototype.getEnvironmentRoute = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.RouteSpecifier.prototype.setEnvironmentRoute = function(value) {
  jspb.Message.setOneofField(this, 6, proto.portal.gloo.solo.io.RouteSpecifier.oneofGroups_[0], value);
};


proto.portal.gloo.solo.io.RouteSpecifier.prototype.clearEnvironmentRoute = function() {
  jspb.Message.setOneofField(this, 6, proto.portal.gloo.solo.io.RouteSpecifier.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.RouteSpecifier.prototype.hasEnvironmentRoute = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.RouteStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.portal.gloo.solo.io.RouteStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.RouteStatus.displayName = 'proto.portal.gloo.solo.io.RouteStatus';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.RouteStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.RouteStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.RouteStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.RouteStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    observedGeneration: jspb.Message.getFieldWithDefault(msg, 1, 0),
    state: jspb.Message.getFieldWithDefault(msg, 2, 0),
    reason: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.RouteStatus}
 */
proto.portal.gloo.solo.io.RouteStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.RouteStatus;
  return proto.portal.gloo.solo.io.RouteStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.RouteStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.RouteStatus}
 */
proto.portal.gloo.solo.io.RouteStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setObservedGeneration(value);
      break;
    case 2:
      var value = /** @type {!proto.common.portal.gloo.solo.io.State} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.RouteStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.RouteStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.RouteStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.RouteStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getObservedGeneration();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 observed_generation = 1;
 * @return {number}
 */
proto.portal.gloo.solo.io.RouteStatus.prototype.getObservedGeneration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.portal.gloo.solo.io.RouteStatus.prototype.setObservedGeneration = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional common.portal.gloo.solo.io.State state = 2;
 * @return {!proto.common.portal.gloo.solo.io.State}
 */
proto.portal.gloo.solo.io.RouteStatus.prototype.getState = function() {
  return /** @type {!proto.common.portal.gloo.solo.io.State} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.common.portal.gloo.solo.io.State} value */
proto.portal.gloo.solo.io.RouteStatus.prototype.setState = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string reason = 3;
 * @return {string}
 */
proto.portal.gloo.solo.io.RouteStatus.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.RouteStatus.prototype.setReason = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.RoutingDestination = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.portal.gloo.solo.io.RoutingDestination.oneofGroups_);
};
goog.inherits(proto.portal.gloo.solo.io.RoutingDestination, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.RoutingDestination.displayName = 'proto.portal.gloo.solo.io.RoutingDestination';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.portal.gloo.solo.io.RoutingDestination.oneofGroups_ = [[1,2,5]];

/**
 * @enum {number}
 */
proto.portal.gloo.solo.io.RoutingDestination.BackendCase = {
  BACKEND_NOT_SET: 0,
  KUBE: 1,
  UPSTREAM: 2,
  CLUSTER_HEADER: 5
};

/**
 * @return {proto.portal.gloo.solo.io.RoutingDestination.BackendCase}
 */
proto.portal.gloo.solo.io.RoutingDestination.prototype.getBackendCase = function() {
  return /** @type {proto.portal.gloo.solo.io.RoutingDestination.BackendCase} */(jspb.Message.computeOneofCase(this, proto.portal.gloo.solo.io.RoutingDestination.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.RoutingDestination.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.RoutingDestination.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.RoutingDestination} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.RoutingDestination.toObject = function(includeInstance, msg) {
  var f, obj = {
    kube: (f = msg.getKube()) && proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.toObject(includeInstance, f),
    upstream: (f = msg.getUpstream()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.toObject(includeInstance, f),
    clusterHeader: jspb.Message.getFieldWithDefault(msg, 5, ""),
    weight: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.RoutingDestination}
 */
proto.portal.gloo.solo.io.RoutingDestination.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.RoutingDestination;
  return proto.portal.gloo.solo.io.RoutingDestination.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.RoutingDestination} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.RoutingDestination}
 */
proto.portal.gloo.solo.io.RoutingDestination.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination;
      reader.readMessage(value,proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.deserializeBinaryFromReader);
      msg.setKube(value);
      break;
    case 2:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.deserializeBinaryFromReader);
      msg.setUpstream(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setClusterHeader(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setWeight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.RoutingDestination.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.RoutingDestination.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.RoutingDestination} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.RoutingDestination.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKube();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.serializeBinaryToWriter
    );
  }
  f = message.getUpstream();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getWeight();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.displayName = 'proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    namespace: jspb.Message.getFieldWithDefault(msg, 2, ""),
    port: jspb.Message.getFieldWithDefault(msg, 3, 0),
    subsetMap: (f = msg.getSubsetMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination}
 */
proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination;
  return proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination}
 */
proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespace(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPort(value);
      break;
    case 4:
      var value = msg.getSubsetMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNamespace();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPort();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getSubsetMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string namespace = 2;
 * @return {string}
 */
proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.prototype.getNamespace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.prototype.setNamespace = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 port = 3;
 * @return {number}
 */
proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.prototype.getPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.prototype.setPort = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * map<string, string> subset = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.prototype.getSubsetMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination.prototype.clearSubsetMap = function() {
  this.getSubsetMap().clear();
};


/**
 * optional KubernetesServiceDestination kube = 1;
 * @return {?proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination}
 */
proto.portal.gloo.solo.io.RoutingDestination.prototype.getKube = function() {
  return /** @type{?proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination} */ (
    jspb.Message.getWrapperField(this, proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination, 1));
};


/** @param {?proto.portal.gloo.solo.io.RoutingDestination.KubernetesServiceDestination|undefined} value */
proto.portal.gloo.solo.io.RoutingDestination.prototype.setKube = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.portal.gloo.solo.io.RoutingDestination.oneofGroups_[0], value);
};


proto.portal.gloo.solo.io.RoutingDestination.prototype.clearKube = function() {
  this.setKube(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.RoutingDestination.prototype.hasKube = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.portal.gloo.solo.io.ObjectRef upstream = 2;
 * @return {?proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.portal.gloo.solo.io.RoutingDestination.prototype.getUpstream = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef, 2));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectRef|undefined} value */
proto.portal.gloo.solo.io.RoutingDestination.prototype.setUpstream = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.portal.gloo.solo.io.RoutingDestination.oneofGroups_[0], value);
};


proto.portal.gloo.solo.io.RoutingDestination.prototype.clearUpstream = function() {
  this.setUpstream(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.RoutingDestination.prototype.hasUpstream = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string cluster_header = 5;
 * @return {string}
 */
proto.portal.gloo.solo.io.RoutingDestination.prototype.getClusterHeader = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.RoutingDestination.prototype.setClusterHeader = function(value) {
  jspb.Message.setOneofField(this, 5, proto.portal.gloo.solo.io.RoutingDestination.oneofGroups_[0], value);
};


proto.portal.gloo.solo.io.RoutingDestination.prototype.clearClusterHeader = function() {
  jspb.Message.setOneofField(this, 5, proto.portal.gloo.solo.io.RoutingDestination.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.RoutingDestination.prototype.hasClusterHeader = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional uint32 weight = 10;
 * @return {number}
 */
proto.portal.gloo.solo.io.RoutingDestination.prototype.getWeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.portal.gloo.solo.io.RoutingDestination.prototype.setWeight = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


goog.object.extend(exports, proto.portal.gloo.solo.io);
